import { propOr } from 'ramda';
import { regularMeal } from 'types/meals';

export const getJourney = (booking, id) => {
  const outbound = propOr([], 'outbound', booking);
  const inbound = propOr([], 'inbound', booking);

  const segments = outbound.concat(inbound);

  return segments.find((segment) => segment.id === id);
};

const { code: REGULAR_MEAL } = regularMeal;

export const buildMeal = ({ passengerFirstName, passengerLastName, mealCode, id }) => ({
  passengerFirstName,
  passengerLastName,
  mealCode: mealCode === REGULAR_MEAL ? null : mealCode,
  passengerId: id
});

export const mergeMeals = (segments, selectedMeals, passengers) => {
  const mealMap = new Map(
    segments
      .map(({ meals }) => meals)
      .flat()
      .map(({ code: mealCode, passenger: { id } }) => {
        const passenger = passengers.find(({ id: passengerId }) => passengerId === id);
        const { firstName: passengerFirstName, lastName: passengerLastName } = passenger;
        const meal = buildMeal({ passengerFirstName, passengerLastName, mealCode, id });

        return [id, meal];
      })
  );

  Object.entries(selectedMeals).forEach(([id, meal]) => mealMap.set(id, meal));

  const mergedMeals = [...mealMap].map(([, meal]) => meal);

  return mergedMeals;
};
